import { lazy } from "react";

/** Public pages — open without login (rendered through PublicRoute, outside MainLayout) */
const VerifySkillPassport = lazy(() => import("../pages/verifySkillPassport/VerifySkillPassport"));
const StudentPublicResume = lazy(() => import("../pages/studentPublicResume/StudentPublicResume"));

const PublicNavigation = [

    /** Skill Passport QR code — /verify/:uskId (uskId = student's encrypted USK ID) */
    {
        id: "verifySkillPassport", path: "/verify/:uskId", exact: true, title: "",
        component: VerifySkillPassport, hasParams: true, text: "Verify Skill Passport"
    },

    /** Mobile app "Generate Resume" — /resume/:uskId (uskId = student's encrypted USK ID) */
    {
        id: "studentPublicResume", path: "/resume/:uskId", exact: true, title: "",
        component: StudentPublicResume, hasParams: true, text: "Student Resume"
    }
];

export default PublicNavigation;
